import React from 'react';
import LocationVehiclePage from './LocationVehiclePage';

const config = {
  city: 'Wise County',
  state: 'TX',
  slug: 'wise-county',
  county: 'Wise County',
  driveTime: '5-25 minutes',
  directions: 'We sit right in the heart of Wise County on FM 1655 in Paradise, TX.',
  nearbyAreas: [
    'Paradise', 'Decatur', 'Bridgeport', 'Alvord', 'Boyd',
    'Rhome', 'Newark', 'Chico', 'Runaway Bay', 'Aurora',
    'Greenwood', 'New Fairview'
  ],
  title: 'Used Cars Wise County TX - Pre-Owned Vehicles From a Local Dealer',
  h1: 'Your Wise County Used Car and Truck Dealer',
  metaDescription: 'Wise County\'s local used car dealer in Paradise, TX. Trucks, cars, golf carts and trailers. Warranty on every vehicle. Financing available. Open Mon-Sat. Call (817) 382-2316.',
  ogDescription: 'The only full-service used vehicle dealer AND repair shop in Wise County. Cars, trucks, golf carts, trailers — all under one roof in Paradise, TX.',
  uniqueContent: {
    heroSubtitle: 'Born and built in Wise County. We sell vehicles and fix them — all from our shop in Paradise, TX.',
    whyBuyIntro: 'Wise County stretches across 922 square miles of North Texas ranch land, small towns and growing communities. Paradise-Performance sits right in the middle of it. We\'re not a DFW mega-lot that claims to serve Wise County from 50 miles away. We live here. We work here. Our customers are our neighbors.',
    buyerBenefits: [
      'The only dealership + full-service repair shop in Wise County',
      'Prices well below DFW dealerships — lower overhead, lower prices',
      'No need to drive to Fort Worth or Denton for a quality vehicle',
      'We know Wise County roads and what vehicles hold up on them',
      'Financing options built for rural Texas — seasonal income OK'
    ],
    contentSections: [
      {
        title: 'Why Wise County Buyers Stay Local',
        body: 'Every time a Wise County resident drives to Fort Worth for a used car, they burn two hours in traffic, get hit with metro dealership markups and end up at a lot that doesn\'t know a county road from a cul-de-sac. We stock vehicles that make sense for Wise County life — trucks for ranches, SUVs for school runs on FM roads, and golf carts for lake properties at Bridgeport and Runaway Bay.'
      },
      {
        title: 'Full-Service Under One Roof',
        body: 'Most used car lots sell you a vehicle and that\'s it. When something breaks, you\'re on your own. Not here. We run a complete repair shop — European car specialist, general maintenance, diesel work. Buy a truck from us and we\'ll maintain it for years. That\'s the difference between a lot and a dealership.'
      },
      {
        title: 'Serving Every Corner of Wise County',
        body: 'Whether you\'re in Decatur near the courthouse, out in Alvord near the lake, up in Bridgeport, or down in Boyd near the Parker County line — we\'re centrally located in Paradise. Most Wise County residents reach us in under 20 minutes. No tolls. No highway merging. Just county roads and a short drive.'
      },
      {
        title: 'Financing for Wise County Residents',
        body: 'We work with lenders who don\'t treat rural Texas like a risk category. First-time buyers, self-employed ranchers, contractors with 1099 income — we find financing that fits. Walk in or apply online. Most decisions come back same day.'
      }
    ]
  },
  faqs: [
    {
      q: 'Where is Paradise-Performance located in Wise County?',
      a: 'We\'re at 305 Co Rd 3470 in Paradise, TX 76073 — right in the center of Wise County. Easy access from Decatur, Bridgeport, Boyd and all surrounding towns.'
    },
    {
      q: 'What vehicles do you sell in Wise County?',
      a: 'Used cars, trucks, SUVs, golf carts and trailers. Our inventory changes weekly. We specialize in trucks under $20K and European vehicles like BMW, Audi and Volkswagen.'
    },
    {
      q: 'Do you service vehicles after the sale?',
      a: 'Yes. We run a full repair shop on the same property. Oil changes, brake work, engine repairs, European car diagnostics — all handled in-house. Wise County\'s only dealership with an attached full-service shop.'
    },
    {
      q: 'Is financing available for bad credit in Wise County?',
      a: 'Yes. We work with lenders who specialize in all credit types — bad credit, no credit, bankruptcy, first-time buyers. Apply online or come in person. Most decisions happen same day.'
    },
    {
      q: 'Do you accept trade-ins from Wise County residents?',
      a: 'Yes. Drive in your current vehicle and we\'ll give you a fair market appraisal on the spot. Trade-in value is applied directly toward your purchase.'
    }
  ]
};

const WiseCounty = () => <LocationVehiclePage config={config} />;
export default WiseCounty;
